import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddHumanPipe } from './add-human.pipe';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [AddHumanPipe],
  imports: [CommonModule, TranslateModule  ],
  exports: [AddHumanPipe],
})
export class AddHumanModule {}
